// extracted by mini-css-extract-plugin
export default {"fallback":"SubtreeErrorBoundary-module__fallback_nWAvx","text":"SubtreeErrorBoundary-module__text_rXjLk"};